import { render, staticRenderFns } from "./NolaNovelData.vue?vue&type=template&id=377f4b02&scoped=true"
import script from "./NolaNovelData.vue?vue&type=script&lang=ts"
export * from "./NolaNovelData.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelData.vue?vue&type=style&index=0&id=377f4b02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f4b02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('377f4b02')) {
      api.createRecord('377f4b02', component.options)
    } else {
      api.reload('377f4b02', component.options)
    }
    module.hot.accept("./NolaNovelData.vue?vue&type=template&id=377f4b02&scoped=true", function () {
      api.rerender('377f4b02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/NolaNovelData.vue"
export default component.exports